import React from 'react'
import CustomTypography from '../../globalStyles/fonts'

const ManagePO = () => {
  return <CustomTypography>Manage PO</CustomTypography>
}
export default ManagePO
